"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FailedToParseManifest = void 0;
const custom_error_1 = require("./custom-error");
class FailedToParseManifest extends custom_error_1.CustomError {
    constructor() {
        super('Failed to parse manifest', custom_error_1.ERROR_CODES.FailedToParseManifest);
    }
}
exports.FailedToParseManifest = FailedToParseManifest;
//# sourceMappingURL=failed-to-parse-manifest.js.map